<template>
  <div class="shop-the-look critical-component-clear">
    <product-card-carousel
      :carousel-data="shopTheLookProducts"
      page-type="product"
      :title="title"
    />
  </div>
</template>

<script>

/**
 * Vue: Shop the look (shop-the-look)
 * -----------------------------------------------------------------------------
 * Renders carousel of products associated with current product or variant based
 * on metafields.
 *
 * @param {Object} product - Current product.
 * @param {Array} productsArray - Array of products.
 * @param {String} title - Section title.
 *
 */
import ProductCardCarousel from '~async/product-card-carousel/product-card-carousel'

export default {
  name: 'ShopTheLook',

  components: {
    ProductCardCarousel,
  },

  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    productsArray: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      shopTheLookProducts: this.productsArray,
      variant: false,
    }
  },

  watch: {
    variant() {
      this.setShopTheLookProducts()
    },
  },

  mounted() {
    this.setEventBusListeners()
    this.setInitialVariant()
    this.setShopTheLookProducts()
  },

  methods: {

    /**
     * Set canvas event bus listeners.
     */
    setEventBusListeners() {
      cnvs.EventBus.listen('update-variant', (variant) => {
        this.variant = variant
      })
    },

    /**
     * Set variant on page load.
     */
    setInitialVariant() {
      const params = new URLSearchParams(document.location.search.substring(1))

      if (!params.get('variant')) {
        this.shopTheLookProducts = this.productsArray
        return
      }

      this.variant = this.product.variants.find((variant) => {
        return variant.id === Number(params.get('variant'))
      })
    },

    /**
     * Set shop the look array based on variant data.
     */
    setShopTheLookProducts() {
      this.shopTheLookProducts = this.variant?.shopTheLookProducts?.length
        ? this.variant.shopTheLookProducts
        : this.productsArray
    },
  },
}
</script>

<style lang="scss">
@import './shop-the-look';
</style>
